import axios from '@/axios';
import * as types from '../mutation-types';

export default {
    namespaced: true,
    state: {
        penalties: [],
        rewards: [],
    },

    actions: {
        fetchAll({ commit }, { employeeIds, dateFrom, dateTo, sectionId, type, page, perPage, punishmentTypeId}) {
            return axios.get('/punishmentReward', {
                params: { employeeIds, dateFrom, dateTo, sectionId, type, NonDeleted: true, page, perPage, punishmentTypeId }
            }).then(({ data, headers }) => {
                return { data, total: +headers['x-pagination-total-count']};
            })
        },

        // fetchAll({ commit }, { employeeIds, dateFrom, dateTo, sectionId, type, page, perPage}) {
        //     const urlSearchParams = new URLSearchParams()
        //     // employeeIds.forEach(employeeId => ());
        //     const params = { dateFrom, dateTo, sectionId, type, page, perPage}
            
        //     Object.keys(params).forEach(param => {
        //         if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
        //     });

        //     employeeIds.forEach(id => {
        //         urlSearchParams.append('employeeIds', id)
        //     })
            
        //     return axios.get('/punishmentReward', { params: urlSearchParams }).then(({ data, headers }) => {
        //         return { data, total: +headers['x-pagination-total-count']};
        //     })
        // },

        create({ commit }, { employeeId, suggestedByEmployeeId, typeId, date, dateOfStarting, notes, valueType, value }) {
            return axios.post('/punishmentReward', { employeeId, suggestedByEmployeeId, typeId, date, dateOfStarting, notes, valueType, value });
        },

        update({ commit }, { id, employeeId, suggestedByEmployeeId, typeId, date, dateOfStarting, notes, valueType, value,details }) {
            return axios.put(`/punishmentReward/${id}`, { employeeId, suggestedByEmployeeId, typeId, date, dateOfStarting, notes, valueType, value, details });
        },

        delete({ commit }, { id }) {
            return axios.delete(`/punishmentReward/${id}`);
        },

        // types
        fetchAllTypes({ commit }) {
            return axios.get('/settingsHr/punishmentAndRewardType').then(({ data }) => {
                commit(types.STORE_PUNISHMENT_REWARD_TYPE, data);
                return data;
            })
        },

        createType({ commit }, { type, name, valueType, value }) {
            return axios.post('/settingsHr/punishmentAndRewardType', { type, name, valueType, value });
        },

        updateType({ commit }, { id, type, name, valueType, value }) {
            return axios.put(`/settingsHr/punishmentAndRewardType/${id}`, { type, name, valueType, value });
        },

        deleteType({ commit }, { id }) {
            return axios.delete(`/SettingsHr/PunishmentAndReward/${id}`);
        }
    },

    mutations: {
        [types.STORE_PUNISHMENT_REWARD_TYPE](state, punishmentRewardTypes) {
            state.penalties = punishmentRewardTypes ? punishmentRewardTypes.punishments : [];
            state.rewards = punishmentRewardTypes ? punishmentRewardTypes.rewards : [];
        }
    },

    getters: {
        getPenaltyById: state => id => state.penalties.find(c => c.id === id),
        getRewardById: state => id => state.rewards.find(c => c.id === id),
    }
}